import { orderedTelemetryColors } from "common/theme/light.theme"

export const useLocalStorageColors = (ids?: string[], masterKey = 'localColors', newColorsArr = orderedTelemetryColors): Record<string, string> => {
 
  let availableColors =  sessionStorage?.getItem(`${masterKey}_availableColors`) 
    ? JSON.parse(sessionStorage.getItem(`${masterKey}_availableColors`) as string) as string[] 
    : newColorsArr.reverse()

  if (availableColors?.length === 0) availableColors = newColorsArr

  let storedColors = 
  sessionStorage?.getItem(`${masterKey}_colors`) 
    ? JSON.parse(sessionStorage.getItem(`${masterKey}_colors`) as string) as Record<string, string> 
    : {}

  const stringiedColors = {} as Record<string, string>
  Object.entries(storedColors).forEach(([key, val]) => stringiedColors[`${key}`] = val)
  
  storedColors = stringiedColors

  if (!ids || ids.length === 0) return storedColors
  else ids.forEach((id) => {
    
    if (availableColors?.length === 0) availableColors = newColorsArr
    if (!storedColors[id]) {
      const [newColor, ...availableColorsRest ]= availableColors
      storedColors[id] = newColor
      availableColors = availableColorsRest
    }
  })

  sessionStorage.setItem(`${masterKey}_colors`, JSON.stringify(storedColors));
  sessionStorage.setItem(`${masterKey}_availableColors`, JSON.stringify(availableColors));

  return storedColors;

}